import i18n from 'i18next';
import { LOCALS } from '../data';

export function normalizeLanguageCode(raw) {
  if (!raw) return LOCALS.EN;
  const lower = String(raw).toLowerCase();
  if (lower.startsWith('uk')) return LOCALS.UK;
  if (lower.startsWith('ru')) return LOCALS.RU;
  if (lower.startsWith('en')) return LOCALS.EN;
  return LOCALS.EN;
}

export function resolveInitialLanguage() {
  const stored = localStorage.getItem('i18nextLng');
  if (stored) return normalizeLanguageCode(stored);
  return LOCALS.EN;
}

export function getActiveLanguageCode() {
  return normalizeLanguageCode(i18n.language || localStorage.getItem('i18nextLng'));
}

export function normalizeSettings(settings = {}) {
  return {
    ...settings,
    language: normalizeLanguageCode(settings.language),
  };
}

export async function syncI18nLanguage(code) {
  const normalized = normalizeLanguageCode(code);
  if (normalizeLanguageCode(i18n.language) !== normalized) {
    await i18n.changeLanguage(normalized);
  }
  localStorage.setItem('i18nextLng', normalized);
  return normalized;
}

export async function applyAppLanguage(code, { dispatch, setLanguageLocal, isLoggedIn, settings, changeSettings }) {
  const normalized = normalizeLanguageCode(code);
  dispatch(setLanguageLocal(normalized));
  await syncI18nLanguage(normalized);

  if (isLoggedIn && changeSettings && settings) {
    const current = normalizeLanguageCode(settings.language);
    if (current !== normalized) {
      dispatch(changeSettings({ ...settings, language: normalized }));
    }
  }

  return normalized;
}
